import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {CostCalculationService} from '../../../Services/cost-calculation.service';
import {CustomToastrService} from '../../../Shared/Services/custom-toastr.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {DtoProductTypeVM} from '../../../Model/cost-calculation/DtoProductTypeVM';
import {DtoColorsVM} from '../../../Model/cost-calculation/DtoColorsVM';
import {DtoCostCalcAddNameVM} from '../../../Model/cost-calculation/DtoCostCalcAddNameVM';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {Subject} from 'rxjs/internal/Subject';
import {UserType} from '../../../Shared/Enums/UserType';
import {Router} from '@angular/router';
import {AuthService} from '../../../Shared/Services/auth.service';
import {
  DtoListSubVM,
  DtoParentSubCategoryVM,
  ProductsWithTypesVM,
  ProductTypesVM
} from '../../../Model/cost-calculation/DtoParentSubCategoryVM';
import {TranslateService} from '@ngx-translate/core';
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs/operators";
import {FloatLabelType} from "@angular/material/form-field";

@Component({
  selector: 'app-cost-calculation-form',
  templateUrl: './cost-calculation-form.component.html',
  styleUrl: './cost-calculation-form.component.scss',
})

export class CostCalculationFormComponent implements OnInit {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  readonly floatLabelControl = new FormControl('auto' as FloatLabelType);
  @Input() Classes: number[] = [];
  @Input() ClassIndex: number = 1;
  @Input() childForm!: FormGroup;
  @Input() AllCostCalcAddsNames: DtoCostCalcAddNameVM[] = [];
  @Input() selectedIds?: number[] = [];
  @Output() ParentForm = new EventEmitter<FormGroup>();
  AllCostNames: string[] = [];
  formGroupName: string = '';

  costCalcData: DtoCostCalcAddNameVM[] = [];
  TypesList!: DtoProductTypeVM[];
  @Input() ColorList!: DtoColorsVM[];
  @Input() AllSubCategory: DtoListSubVM[] = [];
  GlassTypeList!: ProductTypesVM[];
  // Add this property to your component:
  originalHalkTypeList: ProductTypesVM[] = [];
  filteredHalkTypeList: ProductTypesVM[] = [];
  DisplayGlassType: boolean = false;

  constructor(private api: CostCalculationService, private toastrService: CustomToastrService, private translateService: TranslateService,
              private spinner: NgxSpinnerService, private auth: AuthService, private router: Router,private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initForm();
    this.GetLookups();
  }

  get(key: string, index?: number) {
    return this.childForm.get(key + index);
  }

  private initForm() {
    let index = this.formIndex;
    let controls = [
      {"name": "typeId", "value": "", "validators": [Validators.required]},
      {"name": "typeName", "value": "", "validators": null},
      {"name": "colorId", "value": "", "validators": [Validators.required]},
      {"name": "colorName", "value": "", "validators": null},
      {"name": "halkId", "value": "", "validators": null},
      {
        "name": "width",
        "value": "",
        "validators": [Validators.required, Validators.minLength(1), Validators.maxLength(3)]
      },
      {
        "name": "height",
        "value": "",
        "validators": [Validators.required, Validators.minLength(1), Validators.maxLength(3)]
      },
      {
        "name": "count",
        "value": "1",
        "validators": [Validators.required, Validators.minLength(1), Validators.maxLength(3)]
      },
      {"name": "price", "value": "", "validators": [Validators.minLength(1), Validators.maxLength(3)]},
    ];
    this.childForm.addControl('typeId_' + index, new FormControl('', [Validators.required]));
    this.childForm.addControl('typeName_' + index, new FormControl(''));
    this.childForm.addControl('colorId_' + index, new FormControl('', [Validators.required]));
    this.childForm.addControl('halkId_' + index, new FormControl('', ));
    this.childForm.addControl('colorName_' + index, new FormControl(''));
    this.childForm.addControl('width_' + index, new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]));
    this.childForm.addControl('height_' + index, new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]));
    this.childForm.addControl('count_' + index, new FormControl('1', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]));
    this.childForm.addControl('price_' + index, new FormControl('', [Validators.minLength(1), Validators.maxLength(3)]));
    // this.ParentForm.emit(this.childForm);
  }

  GetLookups() {
    this.AllCostCalcAddsNames?.forEach(value => {
      this.AllCostNames.push(value.name!);
    });
    this.checkIfFormHasValues();
  }


  checkIfFormHasValues() {

    if (this.childForm.touched) {
      let idx = this.formIndex;
      Object.keys(this.childForm?.controls).forEach(key => {
        let splited = key.split('_')[0];
        let index = Number(key.split('_')[1]);
        if (this.AllCostNames.includes(splited) && index === idx) {
          let controls = (this.childForm.get(key) as FormArray).controls;
          if (controls != null) {
            if (this.childForm.get(key)?.value.id) {
              let costCalc = this.AllCostCalcAddsNames.find(a => a.id = this.childForm.get(key)?.value.id)
              this.costCalcData?.push(costCalc!);
              this.formGroupName = costCalc?.name! + "_" + index;
            }
          }
        } else {
          if (splited == "typeId") {
            let value = this.get('typeId_', index)?.value;
            this.GetProductsWithTypes(value, index);
          }
        }
      });
    }
  }

  ChangeType(ev?: any) {
    let idx = this.formIndex;
    let optionText = ev.source.selected.viewValue;
    this.childForm.controls["typeName_" + idx].setValue(optionText);

    this.GetProductsWithTypes(ev.source.selected.value, idx);
  }

  GetProductsWithTypes(value?: number, index?: number) {
    this.GlassTypeList = [];
    this.originalHalkTypeList = [];
    this.AllSubCategory?.forEach((sub: DtoListSubVM) => {
      if (sub.id == value) {
        sub.productsWithTypes?.forEach((product: ProductsWithTypesVM) => {
          product.productTypes?.forEach((productType: ProductTypesVM) => {
            if (!this.GlassTypeList.find(g => g.id == productType.id)) {
              this.GlassTypeList.push(productType);
              if(productType.name?.includes('حلق')){

                this.originalHalkTypeList.push(productType);
                this.filteredHalkTypeList = this.originalHalkTypeList;

              }
            }
          });
        });
      }
    });
    this.GlassTypeList = this.GlassTypeList.sort((a: ProductsWithTypesVM, b: ProductsWithTypesVM) => {
      return a?.name?.localeCompare(b?.name ?? '') ?? 0;
    });
    this.DisplayGlassType = this.GlassTypeList?.length !== 0;
    if (this.DisplayGlassType) {
      this.childForm.addControl('glassTypeId_' + index, new FormControl('', [Validators.required]));
      this.childForm.addControl('glassTypeName_' + index, new FormControl('', [Validators.required]));
    } else {
      this.childForm.removeControl('glassTypeId_' + index);
      this.childForm.removeControl('glassTypeName_' + index);
    }
  }

  ChangeGlassType(ev?: any) {
    let optionText = ev.source.selected.viewValue;
    let idx = this.formIndex;
    this.childForm.controls["glassTypeName_" + idx].setValue(optionText);
  }
  ChangeHalkType(ev?: any) {
  const idx = this.formIndex;

  // اكتبه في الكونترول الصحيح مع الـ underscore
  this.childForm.get(`halkId_${idx}`)?.setValue(ev.value);


  }

  ChangeColor(ev?: any) {
    let optionText = ev.source.selected.viewValue;
    let idx = this.formIndex;
    this.childForm.controls["colorName_" + idx].setValue(optionText);
    debugger
    const filteredHalkTypes = this.originalHalkTypeList.filter(h => h.name?.includes(optionText));
    this.filteredHalkTypeList = [...filteredHalkTypes];
  }

  AddDetails(obj?: any, costCalc?: DtoCostCalcAddNameVM) {

    let idx = this.formIndex;
    if (obj?.checked) {
      this.costCalcData?.push(costCalc!);
      this.formGroupName = costCalc?.name! + "_" + idx;
      if (costCalc?.widthAndHeight) {
        this.childForm.addControl(costCalc?.name! + "_" + idx, new FormGroup(
          {
            id: new FormControl(''),
            name: new FormControl(''),
            width: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]),
            height: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]),
            price: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(3)])
          }));
      } else {
        this.childForm.addControl(costCalc?.name! + "_" + idx, new FormGroup(
          {
            id: new FormControl(''),
            name: new FormControl(''),
            value: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(3)])
          }));
      }
    } else {
      let name = costCalc?.name! + "_" + idx;
      this.formGroupName = '';
      this.costCalcData?.splice(this.costCalcData.indexOf(costCalc!), 1);
      this.childForm.removeControl(name);
    }
  }

  RemoveCostCalculationForm() {
    let idx = this.formIndex;
    Object.keys(this.childForm?.controls).forEach(key => {
      let splitedIndex = key.split('_')[1];
      if (Number(splitedIndex) === idx) {
        this.childForm.removeControl(key);
      }
    });
    this.Classes.splice(this.ClassIndex - 1, 1);
  }

  Copy(): void {
    let newIdx = this.Classes[this.Classes.length - 1] + 1;
    let idx = this.formIndex;
    Object.keys(this.childForm?.controls).filter(v => Number(v.split('_')[1]) === this.formIndex).forEach(key => {
      let splited = key.split('_')[0];
      let index = Number(key.split('_')[1]);
      if (this.childForm?.controls[key] instanceof FormGroup) {
        let formGroup = new FormGroup({});
        Object.keys(this.childForm?.controls[key].controls).forEach(groupKey => {
          let control = (this.childForm?.controls[key] as FormGroup).controls[groupKey] as FormControl;
          let validators = this.GetControlValidators(groupKey);
          if (groupKey == 'price') {
            validators.push(Validators.required);
          }
          formGroup.addControl(groupKey, new FormControl(control.value, validators));
        });
        this.childForm.addControl(splited + "_" + newIdx, formGroup);
      } else {
        let control = this.childForm?.controls[key] as FormControl;
        this.childForm.addControl(`${splited}_${newIdx}`, new FormControl(control.value, this.GetControlValidators(splited)));
      }
    });
    this.Classes.push(newIdx);
  }

  GetFocusPlaceholder(cat?: any, key?: any): string {
    let translationKey = "";
    this.translateService.get(key).subscribe((translation: any) => {
      translationKey = translation;
    });

    return cat.placeholder = translationKey;
  }

  protected readonly floatLabel = toSignal(
    this.floatLabelControl.valueChanges.pipe(map(v => v || 'auto')),
    {initialValue: 'auto'},
  );

  checkSelected(cat: DtoCostCalcAddNameVM): boolean {
    let idx = this.formIndex;
    let name = cat?.name! + "_" + idx;
    return !!this.childForm.controls[name]?.value;
  }

  get formIndex(): number {
    return this.Classes[this.ClassIndex - 1];
  }

GetControlValidators(name: string): any {
  return {
    "typeId": [Validators.required],
    "colorId": [Validators.required],
    "halkId": [],              // ✅ جديد
    "width": [Validators.required, Validators.minLength(1), Validators.maxLength(3)],
    "height": [Validators.required, Validators.minLength(1), Validators.maxLength(3)],
    "count": [Validators.required, Validators.minLength(1), Validators.maxLength(3)],
    "price": [Validators.minLength(1), Validators.maxLength(3)],
    "value": [Validators.required, Validators.minLength(1), Validators.maxLength(3)]
  }[name] ?? [];
}

}
